<template>
	<div class="tips">
		<div>
			<div @click="toOnline()">
				<img src="@/assets/image/tips/tips1.png" />
			</div>
		</div>
		<div @click="toOnline()">
			<img src="@/assets/image/tips/tips2.png" />
			<span>在线客服</span>
		</div>
		<div @click="tapLink()">
				<img src="@/assets/image/tips/tips5.png" />
				<span>职称评审</span>
			</div>
		<div>
			<div>
				<img src="@/assets/image/tips/tips3.png" />
				<span>联系电话</span>
			</div>
			<div>
				<div>
					<div>
						<img src="@/assets/image/tips/tips3.png" />
						<span>Hi~欢迎您</span>
					</div>
					<div>0951-7816677</div>
					<div>畅度·为您提供7*24专业服务</div>
				</div>
			</div>
		</div>
		<div>
			<div>
				<img src="@/assets/image/tips/tips4.png" />
				<span>关注公众号</span>
			</div>
		</div>

		<el-dialog class="dialog" title="AI教学助手" :visible.sync="AIDialogVisible" @close="dialogClose"
			:append-to-body="true">
			<div>
				<div class="duix"></div>
				<div>
					<div>
						<div v-for="(item, index) in arr">{{ item.context }}</div>
					</div>
					<div>
						<div>
							<el-input v-model="problem" placeholder="请输入内容"></el-input>
							<el-button class="btn" plain @click="getAiAnswer">发送</el-button>
						</div>
					</div>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { online } from '@/tool/tool';
import DUIX from 'duix-guiji-light'
var duix = new DUIX()
export default {
	data() {
		return {
			AIDialogVisible: false,
			Authorization: '',
			userid: '',
			problem: '',
			arr: []
		}
	},
	mounted() {
		// 实例化 DUIX

		// 监听初始化成功事件
		// duix.on('intialSucccess', () => {
		// 	console.info('初始化成功，准备开始会话')
		// })

		// duix.on('error', data => {
		// 	console.error(data);
		// });

		// duix.on('intialSucccess', () => {
		// 	console.info('intialSucccess');
		// 	// 此时初始化成功，可调用start
		// 	duix.start({
		// 		openAsr: true
		// 	}).then(res => {
		// 		console.info('start', res);
		// 	});
		// });

		// duix.on('speakSection', (data) => {
		// 	console.info('speakSection', data)
		// 	let obj = {
		// 		user: 'ai',
		// 		context: data.text
		// 	}
		// 	this.arr.push(obj)
		// })
		// 初始化 DUIX

	},
	methods: {
		tapLink() {
			// window.location.href='http://222.75.70.73:8001/zcps/';
			// let url = 'http://222.75.70.73:8001/zcps/';
			let url = 'https://ai.changdu-online.com/chat/share?shareId=xFW4WEihaBB3QzortxHEAHsO';
			window.open(url, '_blank')
		},
		toAi() {
			this.AIDialogVisible = true
			this.init()
		},
		dialogClose() {
			if (duix) {
				duix.stop()
			}
		},
		
		getAiAnswer() {
			
		},
		toOnline() {
			online()
			// let url = ''
			// window.open(url, '_blank')
		}
	}
}
</script>

<style scoped lang="scss">
.tips {
	display: flex;
	flex-direction: column;
	align-items: center;
	// position: absolute;
	// right: 20px;
	// bottom: 28px;

	&>div:nth-child(1) {
		width: 98px;
		height: 98px;
		background: #E5EEFB;
		border-radius: 50%;
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 999;

		&>div {
			width: 82px;
			height: 82px;
			background: #D8E7FF;
			border-radius: 50%;
			display: flex;
			justify-content: center;
			align-items: center;

			&>img {
				width: 76px;
				height: 76px;
			}
		}

		// &:hover {
		// 	cursor: pointer;
		// }
	}

	&>div:nth-child(2) {
		width:88px;
		height: 98px;
		background: #E5EFFF;
		border-radius: 10px;
		position: relative;
		top: -30px;
		display: flex;
		flex-direction: column;
		align-items: center;

		&>img {
			width: 40px;
			height: 35px;
			margin-top: 30px;
		}

		&>span {
			font-weight: 500;
			font-size: 14px;
			color: #1A66D8;
			margin-top: 6px;
		}

		&:hover {
			cursor: pointer;
		}
	}
	&>div:nth-child(3){
		width: 88px;
		height: 78px;
		background: #E5EFFF;
		border-radius: 10px;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-top: -27px;
		position: relative;
		display: flex;
			flex-direction: column;
			align-items: center;
			cursor: pointer;
		&>img {
			width:50px;
			height:33px;
			margin-top: 0px;
		}
		&>span {
			font-weight: 500;
			font-size: 14px;
			color: #fe7e08;
			margin-top: 10px;
		}
	}
	&>div:nth-child(4) {
		width: 88px;
		height: 78px;
		background: #E5EFFF;
		border-radius: 10px;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-top: 4px;
		position: relative;

		&>div:nth-child(1) {
			display: flex;
			flex-direction: column;
			align-items: center;

			&>img {
				width: 35px;
				height: 31px;
			}

			&>span {
				font-weight: 500;
				font-size: 14px;
				color: #1A66D8;
				margin-top: 5px;
			}
		}

		&:hover div:nth-child(2) {
			display: block;
		}

		&>div:nth-child(2) {
			display: none;
			width: 268px;
			height: 164px;
			background-image: url('@/assets/image/tips/tips_call.png');
			background-repeat: no-repeat;
			background-size: 100% 100%;
			position: absolute;
			left: -270px;

			&>div {
				width: 100%;
				height: 100%;
				font-weight: bold;
				font-size: 30px;
				color: #222222;
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;

				&>div:first-child {
					display: flex;
					align-items: center;

					&>img {
						width: 40px;
						height: 35px;
						margin-right: 10px;
					}
				}

				&>div:nth-child(2) {
					margin-top: 15px;
				}

				&>div:last-child {
					font-size: 16px;
					color: #666666;
				}
			}
		}

		&:hover {
			cursor: pointer;
		}
	}

	&>div:nth-child(5) {
		width: 88px;
		height: 120px;
		background: #E5EFFF;
		border-radius: 10px;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-top: 3px;

		// position: relative;
		&>div:nth-child(1) {
			display: flex;
			flex-direction: column;
			align-items: center;

			&>img {
				width: 82px;
				height: 82px;
			}

			&>span {
				font-weight: 500;
				font-size: 14px;
				color: #1A66D8;
				margin-top: 10px;
			}
		}

		// &>div:nth-child(2){
		// 	display: none;
		// 	width: 180px;
		// 	height: 180px;
		// 	position: absolute;
		// 	left: -182px;
		// 	&>div{
		// 		&>img{
		// 			width: 100%;
		// 			height: 100%;
		// 		}
		// 	}

		// }
		&:hover div:nth-child(2) {
			display: block;
		}

		&:hover {
			cursor: pointer;
		}
	}


}


::v-deep .el-dialog__wrapper {
	overflow: none !important;
}

::v-deep .el-dialog__body {
	display: flex;
	justify-content: center;

	&>div {
		width: 100%;
		height: 500px;
		border: 2px #1A66D8 solid;
		border-radius: 20px;
		display: flex;

		&>div:nth-child(1) {
			height: 100%;
			width: 260px;
			border-top-left-radius: 20px;
			border-bottom-left-radius: 20px;
			overflow: hidden;
		}

		&>div:nth-child(2) {
			height: 100%;
			flex: 1;
			display: flex;
			flex-direction: column;

			&>div:nth-child(1) {
				height: calc(100% - 60px);
				width: 100%;
				border-top-right-radius: 20px;

				&>div {
					padding: 5px;
					overflow: hidden;
					background-color: antiquewhite;

				}
			}


			&>div:nth-child(2) {
				height: 60px;
				width: 100%;
				padding-top: 20px;

				&>div {
					height: 40px;
					margin: 0px 20px;
					display: flex;
					align-items: center;

					&>.btn {
						margin-left: 20px;
					}
				}
			}
		}
	}
}
</style>